import { render, staticRenderFns } from "./positionManagement.vue?vue&type=template&id=b0288574&scoped=true"
import script from "./positionManagement.vue?vue&type=script&lang=js"
export * from "./positionManagement.vue?vue&type=script&lang=js"
import style0 from "./positionManagement.vue?vue&type=style&index=0&id=b0288574&prod&lang=css"
import style1 from "./positionManagement.vue?vue&type=style&index=1&id=b0288574&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0288574",
  null
  
)

export default component.exports